export const fetchJsonIfOk = async (url, params) => {
  const res = await fetch(url, params);
  if (!res.ok) {
    return null;
  }
  if (res.status === 204) {
    return null;
  }
  return await res.json();
}

export const deleteResource = async (url) => {
  const res = await fetch(url, { method: "DELETE" });
  return res.ok;
}
